export default {

    // return an api url
    apiUrl: state => {
        return state.url;
    },

    // return current take state
    currentTakeValue: state => {
        return state.take;
    }
};